import { StoreDevtoolsModule } from "@ngrx/store-devtools";
import { APP_INITIALIZER, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { EffectsModule } from "@ngrx/effects";
import { TranslateService } from "@ngx-translate/core";

import { StoreUtil } from "./store/utils/store.util";
import { HttpConfigInterceptor } from "@core/interceptors/main.interceptor";
import { GlobalService } from "@core/services/global.services";
import { environment } from "@environments/environment";
import { PopUpNotificationService } from "./services/popup-notification.service";

// Effects
import { GlobalEffect } from "@core/store/effects/global.effect";

// Modules
import { GuardsModule } from "./guards/guards.module";
import { TranslateLoaderUtil } from "@core/translate/translate-loader.util";
import { setTranslate } from "@core/translate/translate.util";

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    GuardsModule,
    StoreUtil.globalStore(),
    TranslateLoaderUtil.initTranslate(),
    HttpClientModule,
    EffectsModule.forRoot([GlobalEffect]),
    StoreDevtoolsModule.instrument({
      maxAge: 25,
      logOnly: !environment.production,
    }),
  ],
  providers: [
    PopUpNotificationService,
    GlobalService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpConfigInterceptor,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: setTranslate,
      deps: [TranslateService],
      multi: true,
    },
  ],
})
export class CoreModule {}
